import {Lens} from '../../lenses/shared/model/lens';
import {Role} from '../model/role';

const USER_INFO_LS_KEY = 'currentUser';
export const PLATFORM_STORAGE_KEY = 'osPlatform';

type LSCurrentUser = {
  email: string;
  username: string;
  roles: Role[];
  lens: Lens;
  token: string;
  timezone?: string;
};

export const getLSUserInfo = (): LSCurrentUser => {
  const user = localStorage.getItem(USER_INFO_LS_KEY);
  return user ? JSON.parse(user) : null;
};

export const setLSUserInfo = (user: LSCurrentUser) => {
  localStorage.setItem(USER_INFO_LS_KEY, JSON.stringify(user));
};

export const setLSUserRole = (role: Role) => {
  const user = getLSUserInfo();
  user.roles[0] = role;
  localStorage.setItem(USER_INFO_LS_KEY, JSON.stringify(user));
};

export const setLSUserLens = (lens: Lens) => {
  const user = getLSUserInfo();
  if (user?.lens) {
    user.lens = lens;
    localStorage.setItem(USER_INFO_LS_KEY, JSON.stringify(user));
  }
};

export const removeLSUserInfo = (): void => {
  localStorage.removeItem(USER_INFO_LS_KEY);
};

export const getPlatformFromStorage = (): 'ios' | 'android' | null => {
  try {
    const stored = localStorage.getItem(PLATFORM_STORAGE_KEY);
    return stored === 'ios' || stored === 'android' ? stored : null;
  } catch {
    return null;
  }
};

export const savePlatformToStorage = (platform: 'ios' | 'android'): void => {
  try {
    localStorage.setItem(PLATFORM_STORAGE_KEY, platform);
  } catch {
    // Silently fail if localStorage is unavailable
  }
};
